import { gql } from '@apollo/client';

export const QUERY_UNIQUE_ATTRIBUTES = gql`
  query uniqueAttributes {
    uniqueAttributes {
      id
      name
    }
  }
`;
